module.exports = __webpack_public_path__ + "static/img/manual-55.b28f036.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-55.png
// module id = /m9u
// module chunks = 4